import React from 'react';
import { Link } from 'gatsby';
import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import Button from '../../components/button';
import { SadWoman } from '../../icons';

const callForActionDataEnglish = {
  header:
    'Measure your experiences of anxiety and depression by taking this 2 minutes online test',
  texts: [
    'Recognition of symptoms is the first step to recovery. Take your first step now.',
  ],
  actionText: 'TAKE THE TEST NOW',
  linkTo: '/questionnaire',
};
const callForActionDataNepali = {
  header: 'के तपाई उदास, चिन्ता या तनाबमा हुनुहुन्छ?',
  texts: [
    'लक्षणको पहिचान तपाईको स्वास्थ्यलाभको लागि पहिलो कदम हो । तलको २ मिनेटको अनलाइन जाँच गरी पहिलो कदम चाल्नुहोस् ।',
  ],
  actionText: 'स्वमूल्यांकन जाँच गर्नुहोस्',
  linkTo: '/questionnaire',
  bannerHeader: 'इच्छा नै शक्ति हो । ',
  bannerText: 'आफ्नो मनको संघर्षलाई अन्त्य गर्ने इच्छा गर्नुहोस् ।',
};

const CallForAction = ({
  header,
  texts,
  actionText,
  linkTo,
  bannerHeader,
  bannerText,
}) => {
  const theme = useTheme();
  return (
    <Grid container>
      <Grid item container>
        <Grid
          item
          xs={6}
          container
          style={{ padding: '0 32px' }}
          alignContent="center"
        >
          <Typography
            variant="h6"
            gutterBottom
            paragraph
            style={{ fontWeight: 600 }}
          >
            {header}
          </Typography>
          {texts.map((text, i) => (
            <Typography key={i} variant="body1" paragraph>
              {text}
            </Typography>
          ))}
          <Box
            width={1}
            my={'32px'}
            display="flex"
            justifyContent="center"
          >
            <Link to="questionnaire">
              <Button size="large">
                {'स्वमूल्यांकन जाँच गर्नुहोस्'}
              </Button>
            </Link>
          </Box>
        </Grid>
        <Grid
          item
          container
          xs={6}
          alignItems="center"
          justify="center"
        >
          <SadWoman width={600} height={480} />
        </Grid>
      </Grid>
      <Grid
        item
        style={{
          width: '100%',
          background: `${theme.palette.secondary.main}`,
          opacity: '0.9',
          padding: 8,
        }}
      >
        <Typography
          variant="h6"
          gutterBottom
          color="primary"
          align="center"
        >
          {bannerHeader.concat(bannerText)}
        </Typography>
      </Grid>
    </Grid>
  );
};

const CallForActionMobile = ({
  header,
  texts,
  actionText,
  linkTo,
  bannerHeader,
  bannerText,
}) => {
  const theme = useTheme();
  return (
    <Grid container>
      <Grid item container xs alignItems="center" justify="center">
        <SadWoman width={600} />
      </Grid>
      <Grid
        item
        style={{
          width: '100%',
          background: `${theme.palette.secondary.main}`,
          opacity: '0.9',
          padding: 8,
        }}
      >
        <Typography
          variant="body2"
          gutterBottom
          color="primary"
          align="center"
          style={{ fontWeight: 600 }}
        >
          {bannerHeader}
        </Typography>
        <Typography
          variant="body2"
          color="primary"
          align="center"
          style={{ fontWeight: 600 }}
        >
          {bannerText}
        </Typography>
      </Grid>
      <Grid
        item
        xs
        container
        style={{ padding: '16px 32px' }}
        alignContent="center"
      >
        <Typography
          gutterBottom
          variant="body1"
          align="center"
          style={{ fontWeight: 600 }}
        >
          {header}
        </Typography>
        {texts.map((text, i) => (
          <Typography key={i} variant="body1" paragraph>
            {text}
          </Typography>
        ))}
        <Box
          width={1}
          my={'16px'}
          display="flex"
          justifyContent="center"
        >
          <Link to="questionnaire">
            <Button size="large">{actionText}</Button>
          </Link>
        </Box>
      </Grid>
    </Grid>
  );
};

const CallForActionSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box width={1} id="home">
      {isMobile ? (
        <CallForActionMobile
          header={callForActionDataNepali.header}
          texts={callForActionDataNepali.texts}
          actionText={callForActionDataNepali.actionText}
          linkTo={callForActionDataNepali.linkTo}
          bannerHeader={callForActionDataNepali.bannerHeader}
          bannerText={callForActionDataNepali.bannerText}
        />
      ) : (
        <CallForAction
          header={callForActionDataNepali.header}
          texts={callForActionDataNepali.texts}
          actionText={callForActionDataNepali.actionText}
          linkTo={callForActionDataNepali.linkTo}
          bannerHeader={callForActionDataNepali.bannerHeader}
          bannerText={callForActionDataNepali.bannerText}
        />
      )}
    </Box>
  );
};

export default CallForActionSection;
